import { render, staticRenderFns } from "./UiTimeline.vue?vue&type=template&id=fa188324"
import script from "./UiTimeline.vue?vue&type=script&lang=js"
export * from "./UiTimeline.vue?vue&type=script&lang=js"
import style0 from "./UiTimeline.vue?vue&type=style&index=0&id=fa188324&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports